import {HeaderMall9} from "../../../../publicComponent/Header";
import Navigator from "../../../../publicComponent/h5/Navigator";
import {useQryMessagePageByApp} from "../../../../api/sysMessageInfo";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import TabsMall9 from "../../../../publicComponent/Tabs/TabMall9";

const statusTabs = [
  {
    label: '未读',
    value: 0
  },
  {
    label: '已读',
    value: 1
  },
];

export default function MessageCenter() {
  const { getList } = useQryMessagePageByApp();
  const [list, setList] = useState([]);
  const [tabActive, setTabActive] = useState(0);
  const { t } = useTranslation();
  
  const changeTab = async (state) => {
    let { data } = await getList({ page: 1, limit: 10, state });
    if (data) {
      setList(data.records);
      setTabActive(state);
    }
  };
  
  useEffect(() => {
    changeTab(0);
  }, []);
  
  
  return (
    <>
      <HeaderMall9/>
      <Navigator title="消息中心" goback noBorder/>
      <Navigator.container className="mdmax:bg-[#f4f4f6]">
        <TabsMall9 fixed
                   tabs={statusTabs}
                   style={{ marginBottom: 0, borderBottom: 0 }}
                   active={tabActive}
                   onChange={changeTab}/>
        
        <div className="md:mt-[40px] mdmax:pt-[40px]">
          {
            list.length > 0 &&
            list.map((item, i) => (
              <div className="py-[22px] mdmax:py-[15px] md:border-b border-[#DFDFDF]
               mdmax:mx-[3%] mdmax:bg-white mdmax:mb-[12px] mdmax:px-[15px] mdmax:rounded-[12px]"
                   key={i}>
                <p className="text-[16px] mb-[8px] mdmax:mb-[5px]">{item.title}</p>
                <p className="text-[14px] mb-[8px] mdmax:text-[#666]">{item.content}</p>
                <p className="text-[14px] text-[#999]">{item.createTime}</p>
              </div>
            ))
          }
        </div>
      </Navigator.container>
    </>
  );
}
